const jobPositionsMenu: any = {
  id: "job-positions",
  title: "Posizioni lavorative",
  translate: "MENU.JOB_POSITIONS",
  type: "collapsible",
  icon: "check-square",
  capability: "show_menu_job_positions",
  order: 13,
  children: [
    {
      id: "job-positions-ads",
      title: "Annunci",
      translate: "MENU.ADS",
      type: "item",
      url: "dashboard/job-positions",
      capability: "show_menu_job_positions_ads",
    },
    {
      id: "candidature_job_positions_list",
      title: "Candidature",
      translate: "CANDIDATURE",
      type: "item",
      url: "dashboard/job-positions-candidature",
      capability: "show_menu_job_positions_candidature",
    },
  ],
};

export default jobPositionsMenu;
